import * as React from 'react';

function Esports(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.586 5.017h-7.1c-4.686 0-7.373 14-3.867 14 2.957 0 3.356-4.094 7.405-4.094 3.275 0 5.198 4.043 7.384 4.043 3.502-.002.865-13.949-3.822-13.949zm-7.07 7c-1.296 0-2.349-1.167-2.349-2.608 0-1.438 1.05-2.605 2.35-2.605 1.296 0 2.347 1.167 2.347 2.605 0 1.439-1.05 2.607-2.348 2.607zm5.826-2.196c-.382-.132-.597-.585-.475-1.011.119-.425.527-.661.91-.529.383.13.6.584.478 1.01-.121.428-.529.663-.913.53zm2.2 1.934c-.181.649-.804 1.012-1.39.808-.584-.202-.909-.893-.725-1.544.182-.649.804-1.012 1.39-.808.584.204.91.896.726 1.544zm-.416-2.835c-.539-.19-.84-.828-.67-1.426.17-.6.743-.934 1.283-.745.54.186.841.827.67 1.424-.168.6-.743.934-1.283.747zm2.01 1.658c-.122.427-.528.663-.912.53-.382-.132-.597-.585-.477-1.013.12-.427.53-.661.91-.53.386.134.6.585.48 1.013zm-8.433-1.13c0 .745-.54 1.345-1.209 1.345-.668 0-1.21-.602-1.21-1.345 0-.74.54-1.342 1.21-1.342.669 0 1.209.602 1.209 1.342z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Esports;
